import {
  getIsConnected,
  getIsMinimize,
  getOnCall,
  getSelectedTab,
  getState,
  getDynamic,
  getPermission,
  getIsOffline
} from "./globalState.selector";

import {
  getInfo,
  getCallList,
  getMonitorState,
  getCallCustomerNumber,
  getCallCustomerName,
  getCallStartTime,
  getCallCurrentTime,
  getTranscriptionSet,
  getTranscriptionUpdate,
  getAgentAssist,
  getSummary,
  getSummaryLoading,
  getCallChecklist
} from "./call.selector";

import {
  getAgentList,
  getFilter,
  getStateList,
  getQueue,
  getLiveDynamic,
  getSingleAgentList,
  getSingleFilter,
  getSingleStateList,
  getSingleQueue,
  getLiveChatData,
  getLiveTranscriptionSet,
  getLiveTranscriptionUpdate,
  getChatSummary,
  getChatSummaryLoading,
} from "./livemonitor.selector";

import { getRecentCallList, getTeam } from "./online.selector";

import { getTeamList, getSelectedTeam } from "./profile.selector";

import { getEmail, getSms } from "./smsemail.selector";
import {
  getAgentStatus,
  getChatDynamic,
  getCurrentChats,
  getImageLoading,
  getLoadingStatus,
  getTypingStatus,
  typingIndicatorCus,
  getChatAgentAssist,
  getAgentTypingStatus,
  updateTranslate,
  getLoadingAgentAssistStatus,
  getDisposeScreen,
  getActiveTab,
  getUniqueTeamIds,
  getActiveTabRight
} from "./chat.selector";

export const globalStateSelector = {
  getIsConnected: (state) => getIsConnected(state),
  getIsOffline: (state) => getIsOffline(state),
  getIsMinimize: (state) => getIsMinimize(state),
  getOnCall: (state) => getOnCall(state),
  getSelectedTab: (state) => getSelectedTab(state),
  getState: (state) => getState(state),
  getInfo: (state) => getInfo(state),
  getCallList: (state) => getCallList(state),
  getRecentCallList: (state) => getRecentCallList(state),
  getTeam: (state) => getTeam(state),
  getTeamList: (state) => getTeamList(state),
  getSelectedTeam: (state) => getSelectedTeam(state),
  getMonitorState: (state) => getMonitorState(state),
  getCallCustomerNumber: (state) => getCallCustomerNumber(state),
  getCallCustomerName: (state) => getCallCustomerName(state),
  getCallStartTime: (state) => getCallStartTime(state),
  getCallCurrentTime: (state) => getCallCurrentTime(state),
  getDynamic: (state, options) => getDynamic(state, options),
  getPermission: (state, options) => getPermission(state, options),
  getTranscriptionSet: (state) => getTranscriptionSet(state),
  getTranscriptionUpdate: (state) => getTranscriptionUpdate(state),
  getAgentAssist: (state) => getAgentAssist(state),
  getSummary: (state) => getSummary(state),
  getSummaryLoading: (state) => getSummaryLoading(state),
  getCallChecklist: (state) => getCallChecklist(state),
};

export const livemonitorSelector = {
  getAgentList: (state, options) => getAgentList(state, options),
  getFilter: (state, options) => getFilter(state, options),
  getStateList: (state, options) => getStateList(state, options),
  getQueue: (state, options) => getQueue(state, options),
  getLiveDynamic: (state, options) => getLiveDynamic(state, options),
  getSingleAgentList: (state, options) => getSingleAgentList(state, options),
  getSingleFilter: (state, options) => getSingleFilter(state, options),
  getSingleStateList: (state, options) => getSingleStateList(state, options),
  getSingleQueue: (state, options) => getSingleQueue(state, options),
  getLiveChatData: (state, options) => getLiveChatData(state, options),
  getLiveTranscriptionSet: (state) => getLiveTranscriptionSet(state),
  getLiveTranscriptionUpdate: (state) => getLiveTranscriptionUpdate(state),
  getChatSummary: (state) => getChatSummary(state),
  getChatSummaryLoading: (state) => getChatSummaryLoading(state),
};

export const smsemailSelector = {
  getEmail: (state) => getEmail(state),
  getSms: (state) => getSms(state),
  // getActiveTab: (state) => getActiveTab(state),
};

export const chatSelector = {
  getChatDynamic: (state, key) => getChatDynamic(state, key),
  getCurrentChats: (state) => getCurrentChats(state),
  getLoadingStatus: (state) => getLoadingStatus(state),
  getAgentStatus: (state) => getAgentStatus(state),
  getImageLoading: (state, id) => getImageLoading(state, id),
  typingIndicatorCus: (state, id) => typingIndicatorCus(state, id),
  getTypingStatus: (state, id) => getTypingStatus(state, id),
  getAgentTypingStatus: (state, id) => getAgentTypingStatus(state, id),
  getChatAgentAssist: (state, id) => getChatAgentAssist(state, id),
  getLoadingAgentAssistStatus: (state) => getLoadingAgentAssistStatus(state),
  getDisposeScreen: (state) => getDisposeScreen(state),
  getActiveTab: (state) => getActiveTab(state),
  getActiveTabRight: (state) => getActiveTabRight(state),
  getUniqueTeamIds: (state) => getUniqueTeamIds(state),
  // updateTranslate: (state, id, translatedText) => updateTranslate(state, id, translatedText),
};
// errorReducer
// globalStateReducer
// onlineStateReducer
// callStateReducer
// profileStateReducer



// WEBPACK FOOTER //
// src/store/selector/index.js